import { faUnderline } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { MarkType } from "prosemirror-model";

import { toggleMark } from "~/lib/prose/commands";

import { type KeysArgs, MarkExtension } from "../extension";

export default class UnderlineMark extends MarkExtension {
	get name() {
		return "underline";
	}

	get mark() {
		return {
			parseDOM: [
				{ tag: "u" },
				{
					style: "text-decoration",
					getAttrs: (value: string) => value === "underline",
				},
			],
			toDOM() {
				return ["u", 0];
			},
		};
	}

	keys({ $type }: KeysArgs) {
		return {
			"Mod-u": toggleMark($type as MarkType, {}),
		};
	}

	menuEntry() {
		return {
			icon: faUnderline,
			title: "Underline",
			run: () => toggleMark(this.$type, {}),
			section: "formatting" as const,
			group: "basic",
			priority: 3,
			keyboardShortcut: this.cmdPlus("U"),
		};
	}
}
